import { api } from "./apiHandler";

/**
 * Ensures a user exists in localStorage. If not, creates a new user with the specified mode.
 * @param {"light"|"dark"} mode - The mode to set for the user.
 * @returns {Promise<void>} Resolves when the user is ensured.
 */
export const ensureUser = async (mode, lang = "en") => {
  const rawHandle = localStorage.getItem("handle");
  const user = rawHandle ? JSON.parse(rawHandle) : null;
  if (user) return;

  const isLight = mode === "light";
  const res = await api.post("/users", {
    user: {
      language_code: lang,
      light_mode_active: isLight,
      dark_mode_active: !isLight,
      handle_set: false,
    },
  });
  
  localStorage.setItem("handle", JSON.stringify(res.data));
};
